import { render, staticRenderFns } from "./userResearch1018.vue?vue&type=template&id=46947c92&scoped=true&"
import script from "./userResearch1018.vue?vue&type=script&lang=js&"
export * from "./userResearch1018.vue?vue&type=script&lang=js&"
import style0 from "./userResearch1018.vue?vue&type=style&index=0&id=46947c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46947c92",
  null
  
)

export default component.exports